import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToasterService } from '../../../shared/toaster/toaster.service';
import { AuthService } from '../../../services/shared/auth.service';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { SocketService } from '../../../services/socket.service';

@Component({
  selector: 'app-login',
  imports: [FormsModule, RouterModule, SpinnerComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  username = '';
  password = '';
  // showForgotModal = false;
  // email = '';
  // otp = '';
  // newPassword = '';
  // otpSent = false;
  // otpValidated = false;
  // otpAttempts = 0;
  // generatedOtp = '';
  spinner: boolean = false;
  spinMessage: string = '';

  constructor(
    private router: Router,
    private toasterService: ToasterService,
    private authService: AuthService,
    private socketService: SocketService
  ) {}

  filterOutLikedAndDisliked(users: any[], liked: any[], disliked: any[]) {
    const likedIds = new Set(liked.map(user => user._id));
    const dislikedIds = new Set(disliked.map(user => user._id));
    return users.filter(user => !likedIds.has(user._id) && !dislikedIds.has(user._id));
  }

  // async onLogin() {
  //   try {
  //     // 1. Get location first
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         const { latitude, longitude } = position.coords;

  //         // 2. Call login with location
  //         const res: any = await this.authService.login(this.username, this.password, { latitude, longitude }).toPromise();
  //         const token = res.token;
  //         const user = res.user;

  //         if (!token || !user) throw new Error('Invalid login response');

  //         sessionStorage.setItem('token', token);
  //         sessionStorage.setItem('user', JSON.stringify(user));
  //         this.socketService.registerUser(user._id);

  //         // Fetch preferences and nearby users as before
  //         const preferences: any = await this.authService.getUserPreferences(token).toPromise();
  //         const liked = preferences.likedUsers || [];
  //         const disliked = preferences.dislikedUsers || [];

  //         const distance = 50000;
  //         const page = 1;
  //         const limit = 24;
  //         const nearbyRes: any = await this.authService
  //           .getNearbyUsers(token, distance, page, limit)
  //           .toPromise();

  //         const filteredUsers = this.filterOutLikedAndDisliked(nearbyRes.nearbyUsers || [], liked, disliked);

  //         sessionStorage.setItem('nearbyUsers', JSON.stringify(filteredUsers));
  //         sessionStorage.setItem('nearbyUsersTotalPages', String(nearbyRes.totalPages));
  //         sessionStorage.setItem('nearbyUsersCurrentPage', String(nearbyRes.page));

  //         this.router.navigate(['/home']);
  //       },
  //       async (error) => {
  //         // If location access denied, login without location
  //         this.toasterService.showToast('Location access denied. Login anyway.', 'warning');
  //         await this.loginWithoutLocation();
  //       }
  //     );
  //   } catch (err: any) {
  //     this.toasterService.showToast(err?.error?.error || 'Login failed', 'error');
  //   }
  // }

async onLogin() {
  if (!this.username?.trim()) {
    this.toasterService.showToast('Please enter username', 'warning');
    return;
  }

  if (!this.password?.trim()) {
    this.toasterService.showToast('Please enter password', 'warning');
    return;
  }

  try {
    this.spinner = true;
    this.spinMessage = 'Checking location...';

    // Attempt to get location first
    let coords: { latitude: number; longitude: number } | null = null;

    try {
      coords = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          pos => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
          err => reject(err)
        );
      });
    } catch {
      // Location denied or failed — show warning but continue login without location
      this.toasterService.showToast('Location access denied. Logging in without location.', 'warning');
    }

    this.spinMessage = 'Logging in...';
    const res: any = await this.authService
      .login(this.username, this.password, coords || undefined)
      .toPromise();

    const token = res.token;
    const user = res.user;
    if (!token || !user) throw new Error('Invalid login response');

    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(user));
    this.socketService.registerUser(user._id);

    this.spinMessage = 'Fetching user preferences...';
    const preferences: any = await this.authService.getUserPreferences(token).toPromise();
    const liked = preferences.likedUsers || [];
    const disliked = preferences.dislikedUsers || [];

    this.spinMessage = 'Finding nearby users...';
    const distance = 50000;
    const page = 1;
    const limit = 24;
    const nearbyRes: any = await this.authService
      .getNearbyUsers(token, distance, page, limit)
      .toPromise();

    const filteredUsers = this.filterOutLikedAndDisliked(
      nearbyRes.nearbyUsers || [],
      liked,
      disliked
    );

    sessionStorage.setItem('nearbyUsers', JSON.stringify(filteredUsers));
    sessionStorage.setItem('nearbyUsersTotalPages', String(nearbyRes.totalPages));
    sessionStorage.setItem('nearbyUsersCurrentPage', String(nearbyRes.page));

    this.router.navigate(['/home']);

  } catch (err: any) {
    this.toasterService.showToast(
      err?.error?.error || err?.message || 'Login failed',
      'error'
    );
  } finally {
    this.spinner = false; // Always hide spinner at the end
    this.spinMessage = '';
  }
}



async loginWithoutLocation() {
  try {
    this.spinner = true;
    this.spinMessage = 'Logging in without location...';

    const res: any = await this.authService.login(this.username, this.password).toPromise();
    const token = res.token;
    const user = res.user;
    const distance = 50000;
    const page = 1;
    const limit = 24;

    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(user));
    this.socketService.registerUser(user._id);

    this.spinMessage = 'Fetching user preferences...';
    const preferences: any = await this.authService.getUserPreferences(token).toPromise();
    const liked = preferences.likedUsers || [];
    const disliked = preferences.dislikedUsers || [];

    this.spinMessage = 'Finding nearby users...';
    const nearbyRes: any = await this.authService
      .getNearbyUsers(token, distance, page, limit)
      .toPromise();

    const filteredUsers = this.filterOutLikedAndDisliked(
      nearbyRes.nearbyUsers || [],
      liked,
      disliked
    );

    sessionStorage.setItem('nearbyUsers', JSON.stringify(filteredUsers));
    sessionStorage.setItem('nearbyUsersTotalPages', String(nearbyRes.totalPages));
    sessionStorage.setItem('nearbyUsersCurrentPage', String(nearbyRes.page));

    this.router.navigate(['/home']);
  } catch (err: any) {
    this.toasterService.showToast(err?.error?.error || 'Login failed', 'error');
  } finally {
    this.spinner = false;
    this.spinMessage = '';
  }
}

  goToRegister() {
    this.router.navigate(['/register']);
  }

  // openForgotPassword() {
  //   this.showForgotModal = true;
  //   this.resetForgotFields();
  // }

  // closeModal() {
  //   this.showForgotModal = false;
  // }

// async sendOtp() {
//   if (!this.email) return;
//   try {
//     this.spinner = true;
//     this.spinMessage = 'Sending OTP...';
//     await this.authService.sendForgotOtp(this.email).toPromise();
//     this.otpSent = true;
//     this.toasterService.showToast('OTP sent to email 📩', 'success');
//   } catch (err: any) {
//     this.toasterService.showToast(err?.error?.error || 'Failed to send OTP', 'error');
//   } finally {
//     this.spinner = false;
//     this.spinMessage = '';
//   }
// }

// async validateOtp() {
//   try {
//     this.spinner = true;
//     this.spinMessage = 'Validating OTP...';
//     await this.authService.verifyForgotOtp(this.email, this.otp).toPromise();
//     this.otpValidated = true;
//     this.toasterService.showToast('OTP verified ✅', 'success');
//   } catch (err: any) {
//     this.otpAttempts++;
//     if (this.otpAttempts >= 5) {
//       this.toasterService.showToast('Too many attempts. Try later 🚫', 'error');
//     } else {
//       this.toasterService.showToast(err?.error?.error || 'Invalid OTP', 'error');
//     }
//   } finally {
//     this.spinner = false;
//     this.spinMessage = '';
//   }
// }

// async updatePassword() {
//   try {
//     this.spinner = true;
//     this.spinMessage = 'Updating password...';
//     await this.authService.resetPassword(this.email, this.newPassword).toPromise();
//     this.toasterService.showToast('Password updated 🎉', 'success');
//     this.closeModal();
//   } catch (err: any) {
//     this.toasterService.showToast(err?.error?.error || 'Update failed', 'error');
//   } finally {
//     this.spinner = false;
//     this.spinMessage = '';
//   }
// }

  // resetForgotFields() {
  //   this.email = '';
  //   this.otp = '';
  //   this.newPassword = '';
  //   this.otpSent = false;
  //   this.otpValidated = false;
  //   this.otpAttempts = 0;
  // }
}